import { FEATURE_FLAGS } from '@/constants/featureFlags';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

export function useMaintenanceMode(): boolean {
  return useFeatureFlag(FEATURE_FLAGS.MAINTENANCE_MODE);
}
